import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { RepositoriesService } from 'app/API';
import type { TGenerateUploadParams } from './types/TGenerateUploadParams';

export const useRepositoryUploadParamsMutation = (): TGenerateUploadParams => {
  const { call } = useAPI();
  const { mutateAsync } = useMutation({
    mutationFn: ({ objectId, file }: Parameters<TGenerateUploadParams>[0]) =>
      call(() => RepositoriesService.generateUploadParams({ repositoryId: objectId, file })),
  });
  return mutateAsync;
};
